import React from 'react'
import { useTheme } from '../../../context/ThemeContext'
import AssetsCards from '../../../components/InventoryDashboard/AssetsCards'
import AssetsVolumeChart from '../../../components/InventoryDashboard/AssetsVolumeChart'
// import StandardsCompliance from '../../../components/InventoryDashboard/StandardsCompliance'
// import LicenseUtilization from '../../../components/InventoryDashboard/LicenseUtilization'
import { MultiSelect } from 'primereact/multiselect'
import PanelHeaderTemplate from '../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate'
import { useInventoryDashboard } from '../../../Hooks/Features/InventoryDashboard/useInventoryDashboard'
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown'

const InventoryDashboard = () => {
    const { theme } = useTheme();
    const { filterValues, options, cardSummary, handleChange, setFilterValues, getAssetSummary } = useInventoryDashboard();

    return (
        <div className='inventory-dashboard' style={{ backgroundColor: theme === "dark" ? "black" : "#d4dbe04d", minHeight: "95vh" }}>
            <div className='w100 m-0 px-4 py-2' >
                <div className='border rounded sk-header-row m-0 d-flex gap-2' style={{ backgroundColor: theme === "dark" ? "#000" : "#fff" }}>
                    <div className="col-md-4 col-12 ms-3">
                        <div >
                            <CommonFilterDropdown fields={[{ key: "locations", label: "Location", col: 6, onHide: () => { if (filterValues?.isChange) { setFilterValues(prev => ({ ...prev, apiCall: { summary: true, volume: true } })) } } }, { key: "assets_card_view_options", label: "Group Cards By", col: 6, type: "dropdown", showClear: false, onHide: () => { if (filterValues?.isChange) { setFilterValues(prev => ({ ...prev, apiCall: { ...prev.apiCall, summary: true } })) } } }]} filterValues={filterValues} setFilterValues={setFilterValues} />
                        </div>
                    </div>
                    {/* <div className="w10">
                        <MultiSelect
                            title="All Type"
                            placeholder="All Type"
                            value={filterValues?.branch}
                            options={options?.branch}
                            optionLabel="branch_name"
                            onChange={(e) => { setFilterValues((prev) => ({ ...prev, branch: e.target.value, isChange: true })); }}
                            filter
                            filterInputAutoFocus
                            className="sk-multiselect"
                            panelClassName="sk-multiselect-panel"
                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'branch', filterValues?.branch, (val) => setFilterValues((prev) => ({ ...prev, branch: val, isChange: true })))} />
                    </div> */}
                    {/* <div className="w10">
                        <MultiSelect
                            title="All Status"
                            placeholder="All Status"
                            value={filterValues?.branch}
                            options={options?.branch}
                            optionLabel="branch_name"
                            onChange={(e) => handleChange(e)}
                            filter
                            filterInputAutoFocus
                            className="sk-multiselect"
                            panelClassName="sk-multiselect-panel"
                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'branch', filterValues?.branch, (val) => setFilterValues((prev) => ({ ...prev, branch: val, isChange: true })))} />
                    </div> */}

                </div>
                <div className='row w100 m-0 p-0'>
                    <div className='col-md-12 col-12 m-0 p-0'>
                        <AssetsCards cardSummary={cardSummary} />
                    </div>
                    <div className='col-lg-12 col-md-12 col-12 m-0 p-0 py-2'>
                        <AssetsVolumeChart option={options} filterValues={filterValues} setFilterValues={setFilterValues} />
                    </div>
                    {/* <div className='col-lg-4 col-md-5  col-12 m-0 p-0 ps-2 '>
                        <div className='col-12 py-2'>
                            <LicenseUtilization />
                        </div>
                        <div className='col-12'>
                            <StandardsCompliance />
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default InventoryDashboard
